import React from "react";
import { Alert, AlertDescription } from "../components/ui/alert";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../components/ui/card";

import { Link } from "react-router-dom";

export default function DefencePrimePathway() {
  return (
    <div className="w-full min-w-0 bg-background text-foreground overflow-x-hidden">
      <div className="mx-auto flex w-full max-w-7xl min-w-0 flex-col gap-6 px-4 py-6 sm:px-6 lg:px-8">
          <section className="w-full space-y-6">
      <Card className="border-border shadow-sm">
      <CardHeader>
      <Badge className="w-fit" variant="secondary">Defence Prime Pathway</Badge>
      <CardTitle className="text-2xl">Existing prime procurement pathway</CardTitle>
      <CardDescription>This MVP keeps the prime path intentionally lightweight to highlight the comparative support value of the dual-use on-ramp.</CardDescription>
      </CardHeader>
      <CardContent className="flex flex-wrap gap-3">
      <Button asChild><Link to="/dual-use-on-ramp">Go to Dual-Use On-Ramp</Link></Button>
      <Button asChild variant="outline"><Link to="/opportunities">Browse Opportunities</Link></Button>
      </CardContent>
      </Card>

      <Card className="border-border shadow-sm">
      <CardHeader>
      <CardTitle>Current State (MVP Placeholder)</CardTitle>
      <CardDescription>Current defence procurement mechanisms remain available and are not replaced by this platform.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-3 text-sm text-muted-foreground">
      <p>• Complex entry landscape across multiple programs.</p>
      <p>• Program-specific process requirements and timelines.</p>
      <p>• Limited translation support for non-traditional entrants.</p>
      <Alert>
      <AlertDescription>This path is presented for comparison with the dual-use route and shared opportunities index.</AlertDescription>
      </Alert>
      </CardContent>
      </Card>
      </section>
      </div>
    </div>
  );
}